import { CreditSummary } from '../../models';

export const creditSummaryMilesMocks: CreditSummary = {
  statementCredit: '-2,000 miles',
  statementCreditLabel: 'AMEX Statement Credit*',
  totalLabel: 'Total After Statement Credit',
  total: {
    multiUnit: true,
    cash: {
      value: '80',
      fraction: '',
      symbol: '$',
      code: 'USD'
    },
    miles: {
      value: '5,000',
      code: 'MILES'
    }
  }
};
